import {
    HTTP
} from '../http-common'

const snackbarDefaults = {
    info:  {color: 'info',  icon: 'done_outline', text: ''},
    error: {color: 'error', icon: 'error',        text: 'Помилка! '}
}

export default {
    state: {
        cardOpened: false,
        navigationDrawerOpened: false,
        cardContractorsOpened: false,
        cardContactsOpened: false,
        cardContractorsAddressesOpened: false,
        userInfo : {},
        now: Date.now(),
        snackbar: {
            model:  false,
            color: '',
            icon:  '',
            text:  ''
        }
    },
    mutations: {
        openCloseCard (state, payload) {
                state.cardOpened = payload
        },  
        openCloseContractors (state, payload) {
            state.cardContractorsOpened = payload
        },
        openCloseContractorsAddresses (state, payload) {
            state.cardContractorsAddressesOpened = payload
        },
        openCloseContacts (state, payload) {
            state.cardContactsOpened = payload
        },
        openCloseNavigationDrawer (state, payload) {
            state.navigationDrawerOpened = payload
        } ,
        setUserInfo (state, payload) {
            state.userInfo = payload  
        },
        updateTime (state) {
            state.now = Date.now()
        },
        updateSnackbar(state, payload) {
            state.snackbar = payload
        }
    },
    actions: {
        getUserInfo({commit}){
            return new Promise ((resolve, reject) => {
                HTTP.get('/auth/user-info')
                .then(response => {
                    commit('setUserInfo', response.data.data)
                    resolve(response.data.data)
                })
            })
        },
        start ({ commit }) {
            setInterval(() => {
              commit('updateTime')
            }, 1000 * 60 )
        },
        setSnackbar({commit}, [type, text]) {
            let data = {...snackbarDefaults[type], text: snackbarDefaults[type || 'error'].text + (text || '') , model: true}
            commit('updateSnackbar', data)
        },
    },
    getters: {
        userInfo(state) {
            return state.userInfo
        },
        snackbar(state) {
            return state.snackbar
        },
        NOW(state) {
            return state.now
        }
    }
}